import { motion } from 'framer-motion';
import { ArrowRight, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLang } from '../../../context/LangContext';
import { fadeInUp } from '../../../animations/variants';

const CALENDLY_URL = "https://calendly.com/elite-help";

export const HomeCTA = () => {
  const { t } = useLang();

  return (
    <section data-testid="home-cta-section" className="relative py-24 md:py-32 bg-[#020209] overflow-hidden">
      {/* Radial gradient bg */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(84,161,51,0.08),transparent_70%)]" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <motion.h2
          {...fadeInUp}
          className="text-3xl md:text-5xl font-bold text-white tracking-tight mb-4"
        >
          {t("cta.title")}
        </motion.h2>
        <motion.p
          {...fadeInUp}
          className="text-neutral-400 text-lg mb-10"
        >
          {t("cta.subtitle")}
        </motion.p>

        <motion.div
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, type: "spring", stiffness: 55, damping: 18 }}
        >
          {/* Voir les tarifs -> /tarifs */}
          <Link
            to="/tarifs"
            data-testid="home-cta-tarifs"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-gradient-to-r from-brand-green to-brand-blue text-white font-semibold transition-all hover:shadow-lg hover:shadow-brand-green/20"
          >
            <ArrowRight size={18} />
            {t("cta.primary")}
          </Link>
          {/* Réserver un appel -> Calendly */}
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="home-cta-calendly"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl border border-white/[0.1] bg-white/[0.02] text-white font-semibold hover:bg-white/[0.05] transition-all"
          >
            <Calendar size={18} />
            {t("cta.secondary")}
          </a>
        </motion.div>
      </div>
    </section>
  );
};
